module.exports = __webpack_public_path__ + "static/img/home.4e7130e.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/home.png
// module id = fA5/
// module chunks = 7